import { render, staticRenderFns } from "./cost-detail-table.vue?vue&type=template&id=5a0d44e2&scoped=true"
import script from "./cost-detail-table.vue?vue&type=script&lang=js"
export * from "./cost-detail-table.vue?vue&type=script&lang=js"
import style0 from "./cost-detail-table.vue?vue&type=style&index=0&id=5a0d44e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0d44e2",
  null
  
)

export default component.exports